/* loaded by smart-asset */
export default require("./keyboard_arrow_up-24px~Lrlcugmz.svg")